module.exports = __webpack_public_path__ + "img/ringsize@2x.fcf4fa3.jpg";